import { render, staticRenderFns } from "./mainContent.vue?vue&type=template&id=71de2ee8&scoped=true"
import script from "./mainContent.vue?vue&type=script&lang=js"
export * from "./mainContent.vue?vue&type=script&lang=js"
import style0 from "./mainContent.vue?vue&type=style&index=0&id=71de2ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de2ee8",
  null
  
)

export default component.exports